import { createFileRoute } from "@tanstack/react-router";

import CasingPage from "@/app/design-system/casing/CasingPage";

export const Route = createFileRoute("/admin/design-system/casing")({
  component: CasingPage,
});
